import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'echeck-help',
  template: `
    <div class="container">
      <div (click)="openEcheckModal(content)" class="e-check-link">
        Where do I find these numbers?
      </div>
      <ng-template #content let-c="close" let-d="dismiss">
        <div class="modal-header d-block text-center container">
          <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="d('Cross click')"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="row">
            <p class="echeck-help-text col-12">
              On the bottom of your checks, you will see three groups of
              numbers. Usually the first one is your routing number, and the
              second is your account number.
            </p>
          </div>
        </div>
        <div class="modal-body container">
          <div class="echeck-instructions"></div>
        </div>
      </ng-template>
    </div>
  `
})
export class EcheckHelpComponent implements OnInit {
  modalReference: NgbModalRef;

  constructor(private modalService: NgbModal) {}
  ngOnInit() {}
  openEcheckModal(content) {
    this.modalReference = this.modalService.open(content, { size: 'lg' });
  }
}
